import CodeInput from './code-input';

export default CodeInput;
